//@ts-ignore
import React from "react";
import "./index.css";
import { Provider } from "react-redux";


import { AppConfig } from "./App";
//@ts-ignore
import store from "./store/store";

// import { GlobalFont } from "./fonts";

import { Global, css } from '@emotion/react'


//@ts-ignore
import futura_pt_bold_ttf from "./fonts/futura-pt-bold.ttf";
//@ts-ignore
import futura_pt_bold_woff from "./fonts/futura-pt-bold.woff";
//@ts-ignore
import futura_pt_bold_woff2 from "./fonts/futura-pt-bold.woff2";
//@ts-ignore
import futura_pt_medium_ttf from "./fonts/futura-pt-medium.ttf";
//@ts-ignore
import futura_pt_medium_woff from "./fonts/futura-pt-medium.woff";
//@ts-ignore
import futura_pt_medium_woff2 from "./fonts/futura-pt-medium.woff2";
//@ts-ignore
import futura_pt_book_woff2 from "./fonts/futura-pt-book.woff2";
//@ts-ignore
import futura_pt_book_woff from "./fonts/futura-pt-book.woff";
//@ts-ignore
import futura_pt_book_ttf from "./fonts/futura-pt-book.ttf";
//@ts-ignore
import Oswald_Bold_ttf from "./fonts/Oswald-Bold.ttf";
//@ts-ignore
import Oswald_Bold_woff from "./fonts/Oswald-Bold.woff";
//@ts-ignore
import Oswald_Bold_woff2 from "./fonts/Oswald-Bold.woff2";

export type initializationThreeKitDataT = {
  threekitUrl: string,
  authToken: string,
  assetId: string,
}
export type ConfigurationAppT = {
  initializationThreekit: initializationThreeKitDataT
}

export const ConfigurationApp = ({ ...props }: ConfigurationAppT) => {
 
  return (
    <Provider store={store}>
      <Global
        styles={css`
    @font-face {
      font-family: "Futura PT";
      src:  url(${futura_pt_book_woff2}) format("woff2"),
        url(${futura_pt_book_woff}) format("woff"), url(${futura_pt_book_ttf}) format("truetype");
      font-weight: 400;
      font-style: normal;
    } 
    @font-face {
      font-family: "Futura PT";
      src:  url(${futura_pt_medium_woff2}) format("woff2"),
        url(${futura_pt_medium_woff}) format("woff"), url(${futura_pt_medium_ttf}) format("truetype");
      font-weight: 450;
      font-style: normal;
    }
    @font-face {
      font-family: "Futura PT";
      src:  url(${futura_pt_bold_woff2}) format("woff2"),
        url(${futura_pt_bold_woff}) format("woff"), url(${futura_pt_bold_ttf}) format("truetype");
      font-weight: 600;
      font-style: normal;
    }
    @font-face {
      font-family: "Oswald";
      src:  url(${Oswald_Bold_woff2}) format("woff2"),
        url(${Oswald_Bold_woff}) format("woff"), url(${Oswald_Bold_ttf}) format("truetype");
      font-weight: 600;
      font-style: normal;
    }
  `}
      />
      <AppConfig initializationThreekit={props.initializationThreekit} />
    </Provider>
  );
};
